import React from 'react';

export const TypeUnknown: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 3C4.5 3 3.5 3.5 3.5 5L3.5 7C3.5 7.5 3 8 2.5 8C3 8 3.5 8.5 3.5 9L3.5 11C3.5 12.5 4.5 13 5.5 13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 3C11.5 3 12.5 3.5 12.5 5L12.5 7C12.5 7.5 13 8 13.5 8C13 8 12.5 8.5 12.5 9L12.5 11C12.5 12.5 11.5 13 10.5 13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="6.5" cy="8" r="0.5" fill="currentColor" />
    <circle cx="9.5" cy="8" r="0.5" fill="currentColor" />
  </svg>
);
